import { Link } from '@tanstack/react-router'
import { AppHeader } from '#/components/layout/app-header'
import { m } from '#/paraglide/messages'

const CONTACT_EMAIL = 'hello@bystep.dev'

export type LegalSection = { h: string; p: string }

export function LegalPage({ title, intro, sections, otherHref, otherLabel }: { title: string; intro: string; sections: LegalSection[]; otherHref: '/privacy' | '/terms'; otherLabel: string }) {
  return (
    <>
      <AppHeader />
      <main className="flex-1 overflow-y-auto px-6 py-10">
        <article className="mx-auto w-full max-w-3xl">
          <h1 className="text-3xl font-bold">{title}</h1>
          <p className="mt-1 text-sm text-muted-foreground">{m.legal_updated()}</p>
          <p className="mt-6 text-muted-foreground">{intro}</p>
          <ol className="mt-8 space-y-6">
            {sections.map((s, i) => (
              <li key={s.h}>
                <h2 className="text-lg font-semibold">{i + 1}. {s.h}</h2>
                <p className="mt-1 leading-relaxed text-muted-foreground">{s.p}</p>
              </li>
            ))}
          </ol>
          <footer className="mt-10 flex flex-wrap items-center justify-between gap-3 border-t pt-6 text-sm text-muted-foreground">
            <span>{m.legal_contact({ email: '' })}<a className="underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></span>
            <Link className="underline" to={otherHref}>{otherLabel}</Link>
          </footer>
        </article>
      </main>
    </>
  )
}
